import { render, staticRenderFns } from "./FormInputGeoCoordinates.vue?vue&type=template&id=55f05273&"
import script from "./FormInputGeoCoordinates.vue?vue&type=script&lang=ts&"
export * from "./FormInputGeoCoordinates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports